PJQ.views.invoices = {};

PJQ.constants.invoices = {
    view: {
        INVOICES: 'invoices',
        TRANSACTIONS: 'transactions'
    },
    invoiceDateRange: {
        MONTH_TO_DATE: -1,
        DAYS_30: 30,
        DAYS_60: 60,
        DAYS_90: 90,
        DAYS_180: 180,
        YEAR_TO_DATE: -10
    },
    invoiceStatus: {
        DRAFT: 0,
        PAYMENT_REQUESTED: 1,
        PENDING: 2,
        PAID: 3,
        VOIDED: 4,
        REFUNDED: 5,
        RETURNED: 6
    },
    invoiceStatusNames: {
        0: 'Draft',
        1: 'Payment Requested',
        2: 'Pending',
        3: 'Paid',
        4: 'Voided',
        5: 'Refunded',
        6: 'Returned'
    },
    transactionType: {
        PAYMENT_PENDING: 0,
        PAYMENT: 1,
        VOID: 2,
        REFUND_PENDING: 3,
        REFUND: 4,
        RETURN: 5,
    },
    transactionTypeNames: {
        0: 'Pending Payment',
        1: 'Payment',
        2: 'Void',
        3: 'Pending Refund',
        4: 'Refund',
        5: 'Return'
    },
    paymentType: {
        EXTERNAL: 0,
        CREDIT_CARD_PAYSIMPLE: 1,
        ACH_PAYSIMPLE: 2
    },
    paymentTypeNames: {
        0: 'External',
        1: 'Credit Card',
        2: 'Check (ACH)'
    },
    notificationType: {
        PAYMENT_REQUESTED: 1,
        PAYMENT_REQUEST_REMINDER: 2,
        PAYMENT: 3,
        VOIDED: 4,
        REFUNDED: 5,
        SETTLED: 6,
        RETURNED: 7,
        RECEIPT: 8
    },
    notificationTypeNames: {
        1: 'Request Payment',
        2: 'Payment Reminder',
        3: 'Invoice Payment',
        4: 'Invoice Voided',
        5: 'Invoice Refunded',
        6: 'Payment Settled',
        7: 'Payment Returned',
        8: 'Invoice Receipt'
    },
    checkingAccountType: {
        CHECKING : 'checking',
        SAVINGS: 'savings'
    }

};

if (PJQ.app.module === PJQ.constants.modules.INVOICES) {
    PJQ.app.addOldRoutes([
        {
            route: '',
            name: 'default',
            callback: function () {
                PJQ.app.router.navigate('invoices', {
                    trigger: true,
                    replace: true
                });
            }
        }
    ]);
}

PJQ.modules.invoices = {
    routes: [
        {
            route: 'invoices',
            name: 'invoices',
            callback: function () {
                PJQ.app.session.project = null;
                if (PJQ.app.session.get('ownsPortal')) {
                    PJQ.app.initNavigator({
                        activeItem: "invoices"
                    });
                }
                else {
                    PJQ.app.initNavigator();
                }
            }
        },
        {
            route: 'invoices/:invoiceId',
            name: 'invoiceLink',
            callback: function (invoiceId) {
                if (PJQ.app.session.get('ownsPortal')) {
                    PJQ.app.initNavigator({
                        activeItem: "invoices",
                        viewOptions: {
                            invoiceId: parseInt(invoiceId)
                        }
                    });
                }
                else {
                    PJQ.app.initNavigator();
                }
            }
        },
        {
            route: 'invoices/:invoiceId/context/:context',
            name: 'invoiceGuestLink',
            callback: function (invoiceId, context) {

                let invoice = new PJQ.models.invoices.Invoice({
                    invoiceId: invoiceId,
                    context: context
                });

                invoice.fetch({
                    success: function() {
                        new PJQ.views.invoices.InvoicePayor({
                            el: PJQ.app.$el,
                            invoice: invoice
                        });
                    },
                    error: function() {
                        let tmp = new PJQ.templating.Template(PJQ.constants.modules.INVOICES, 'invoice-not-available');
                        PJQ.templating.TemplateRenderer.renderTemplate(false, tmp, PJQ.app.$el);
                    }
                });

            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.invoices.routes);
